const DAY_MS = 24 * 60 * 60 * 1000;

// ETAs are stored as midnight on the expected day, so the date only counts as
// passed once that whole day is over.
export const isEtaPassed = (eta) => {
    if (!eta) return false;
    const time = new Date(eta).getTime();
    return !Number.isNaN(time) && time + DAY_MS <= Date.now();
};
